import { useMemo } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import AbsencePage from "./AbsencePage";

const AbsenceAllEntriesPage = () => {
  const { t } = useTranslation();
  const { serviceModuleId } = useParams<{ serviceModuleId: string }>();
  const parsedServiceModuleId = Number(serviceModuleId);

  const breadcrumbs = useMemo(
    () => [
      {
        title: "serviceModulesPage.serviceModules",
        link: "serviceModules",
      },
      {
        title: t("serviceModulesPage.absencePage.allEntriesCard.title"),
        link: `serviceModules/absence/${serviceModuleId}/all`,
      },
    ],
    [serviceModuleId, t]
  );

  return (
    <>
      <PageTitle
        breadcrumbs={breadcrumbs}
        title={t("serviceModulesPage.absencePage.allEntriesCard.title")}
      />
      <Box sx={{ mt: 3 }}>
        <AbsencePage
          serviceModuleId={Number.isFinite(parsedServiceModuleId) ? parsedServiceModuleId : -1}
          hidePageTitle
        />
      </Box>
    </>
  );
};

export default AbsenceAllEntriesPage;
